import { motion } from 'framer-motion'
import { styled } from 'styled-components'

import { mq } from 'styles/mq'
import { typography } from 'styles/typography'

export const SectionWrapper = styled.section`
  --margin: 18rem;

  margin-block: var(--margin);
  scroll-margin-block: calc(5rem);

  ${mq.large} {
    --margin: 24rem;
  }
`

export const Title = styled(motion.h2)`
  ${typography.heading.h2}
  margin: 0 0 3rem;
  color: var(--primary-color);
  text-align: center;
  position: relative;
`
